/* Baby Doe — theme interactions (vanilla, progressive) */
(function () {
  "use strict";
  const $ = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => Array.from(c.querySelectorAll(s));

  /* ---- sticky header shadow ---- */
  const header = $(".header");
  if (header) {
    const onScroll = () => header.classList.toggle("is-stuck", window.scrollY > 8);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* ---- mobile nav (focus management + background inert) ---- */
  const drawer = $(".mobile-nav");
  const openBtn = $("[data-nav-open]");
  const closeBtn = $("[data-nav-close]");
  const bg = [$(".header"), $("main"), $(".footer"), $(".announce")].filter(Boolean);
  const setNav = (open) => {
    if (!drawer) return;
    drawer.classList.toggle("is-open", open);
    document.body.style.overflow = open ? "hidden" : "";
    if (openBtn) openBtn.setAttribute("aria-expanded", String(open));
    bg.forEach((el) => (open ? el.setAttribute("inert", "") : el.removeAttribute("inert")));
    if (open) (closeBtn || drawer).focus();
    else if (openBtn) openBtn.focus();
  };
  openBtn && openBtn.addEventListener("click", () => setNav(true));
  closeBtn && closeBtn.addEventListener("click", () => setNav(false));
  drawer && $$("a", drawer).forEach((a) => a.addEventListener("click", () => setNav(false)));
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && drawer && drawer.classList.contains("is-open")) setNav(false);
  });

  /* ---- scroll reveal (bulletproof: anything at/above the 90% line reveals) ---- */
  const reveals = $$(".reveal");
  if (reveals.length) {
    let pending = reveals.slice();
    let ticking = false;
    const check = () => {
      ticking = false;
      const vh = window.innerHeight;
      for (let i = pending.length - 1; i >= 0; i--) {
        if (pending[i].getBoundingClientRect().top < vh * 0.9) {
          pending[i].classList.add("in");
          pending.splice(i, 1);
        }
      }
    };
    const onScroll = () => { if (!ticking) { ticking = true; requestAnimationFrame(check); } };
    window.addEventListener("scroll", onScroll, { passive: true });
    window.addEventListener("resize", onScroll, { passive: true });
    window.addEventListener("load", check);
    check();
  }

  /* ---- product gallery: thumbnails swap the main image ---- */
  const mainImg = $("[data-gallery-main]");
  const thumbs = $$("[data-thumb]");
  if (mainImg && thumbs.length) {
    mainImg.style.transition = "opacity .25s ease, transform .7s cubic-bezier(.22,.61,.36,1)";
    // Warm the browser cache so subsequent clicks are instant
    const cache = new Map();
    thumbs.forEach((t) => {
      const s = t.getAttribute("data-src");
      if (!s || cache.has(s)) return;
      const pre = new Image();
      pre.decoding = "async";
      pre.src = s;
      cache.set(s, pre);
    });
    let seq = 0;
    const applyView = (t) => {
      const src = t.getAttribute("data-src");
      const alt = t.getAttribute("data-alt") || mainImg.alt;
      const pos = t.getAttribute("data-pos") || "center";
      const scale = t.getAttribute("data-scale") || "1";
      thumbs.forEach((x) => x.setAttribute("aria-pressed", "false"));
      t.setAttribute("aria-pressed", "true");
      if (!src || src === mainImg.getAttribute("src")) {
        mainImg.style.objectPosition = pos;
        mainImg.style.transform = "scale(" + scale + ")";
        return;
      }
      const my = ++seq;
      const commit = () => {
        if (my !== seq) return; // superseded by a later click
        mainImg.setAttribute("src", src);
        mainImg.removeAttribute("srcset");
        mainImg.alt = alt;
        mainImg.style.objectPosition = pos;
        mainImg.style.transform = "scale(" + scale + ")";
        // Decode the newly-assigned image, then fade back in
        const done = () => { if (my === seq) mainImg.style.opacity = "1"; };
        if (mainImg.decode) mainImg.decode().then(done, done);
        else if (mainImg.complete) done();
        else mainImg.addEventListener("load", done, { once: true });
      };
      mainImg.style.opacity = "0";
      const pre = cache.get(src) || (function () { const p = new Image(); p.src = src; cache.set(src, p); return p; })();
      if (pre.complete && pre.naturalWidth > 0) commit();
      else {
        pre.addEventListener("load", commit, { once: true });
        pre.addEventListener("error", () => { if (my === seq) mainImg.style.opacity = "1"; }, { once: true });
      }
    };
    thumbs.forEach((t) => t.addEventListener("click", () => applyView(t)));
  }

  /* ---- variant picker: pretty pills drive the real <select name="id"> ---- */
  const picker = $("[data-variant-picker]");
  if (picker) {
    const select = $("[data-variant-select]", picker);
    const btns = $$("[data-variant-btn]", picker);
    const label = $("[data-selected-label]", picker);
    const priceNow = $("[data-price-now]");
    const addPrice = $("[data-add-price]");
    if (select) {
      const sync = () => {
        const id = select.value;
        let chosen = null;
        btns.forEach((b) => {
          const on = b.dataset.variantId === id;
          b.setAttribute("aria-pressed", on ? "true" : "false");
          if (on) chosen = b;
        });
        if (chosen) {
          if (label) label.textContent = chosen.textContent.trim();
          if (chosen.dataset.price) {
            if (priceNow) priceNow.textContent = chosen.dataset.price;
            if (addPrice) addPrice.textContent = chosen.dataset.price;
          }
        }
      };
      btns.forEach((b) =>
        b.addEventListener("click", () => {
          if (b.hasAttribute("disabled")) return;
          select.value = b.dataset.variantId;
          select.dispatchEvent(new Event("change", { bubbles: true }));
        })
      );
      select.addEventListener("change", sync);
      sync();
    }
  }

  /* ---- quantity stepper ---- */
  const qtyWrap = $("[data-qty]");
  if (qtyWrap) {
    const input = $("input", qtyWrap);
    $$("button", qtyWrap).forEach((b) => {
      b.addEventListener("click", () => {
        const dir = b.dataset.step === "down" ? -1 : 1;
        input.value = Math.max(1, (parseInt(input.value, 10) || 1) + dir);
      });
    });
  }

  /* ---- accordion (measured-height animation; collapsed panels hidden from AT) ---- */
  $$(".acc__item").forEach((item) => {
    const head = $(".acc__head", item);
    const panel = $(".acc__panel", item);
    if (!head || !panel) return;
    const startOpen = item.classList.contains("is-open");
    panel.style.height = startOpen ? "auto" : "0px";
    head.setAttribute("aria-expanded", String(startOpen));
    if (!startOpen) { panel.setAttribute("aria-hidden", "true"); panel.setAttribute("inert", ""); }
    head.addEventListener("click", () => {
      const open = item.classList.toggle("is-open");
      head.setAttribute("aria-expanded", String(open));
      if (open) {
        panel.removeAttribute("aria-hidden");
        panel.removeAttribute("inert");
        panel.style.height = panel.scrollHeight + "px";
        const done = () => { if (item.classList.contains("is-open")) panel.style.height = "auto"; panel.removeEventListener("transitionend", done); };
        panel.addEventListener("transitionend", done);
      } else {
        panel.style.height = panel.scrollHeight + "px";
        requestAnimationFrame(() => requestAnimationFrame(() => { panel.style.height = "0px"; }));
        panel.setAttribute("aria-hidden", "true");
        panel.setAttribute("inert", "");
      }
    });
  });

  /* ---- modals (size guide, etc.) ---- */
  let lastFocused = null;
  const closeModal = (modal) => {
    modal.classList.remove("is-open");
    modal.hidden = true;
    document.body.style.overflow = "";
    if (lastFocused) { lastFocused.focus(); lastFocused = null; }
  };
  $$("[data-modal-open]").forEach((btn) => {
    const modal = document.getElementById(btn.getAttribute("data-modal-open"));
    if (!modal) return;
    btn.addEventListener("click", () => {
      lastFocused = btn;
      modal.hidden = false;
      modal.classList.add("is-open");
      document.body.style.overflow = "hidden";
      const focusTarget = modal.querySelector(".modal__close") || modal.querySelector(".modal__panel");
      if (focusTarget && focusTarget.focus) focusTarget.focus();
    });
  });
  $$("[data-modal]").forEach((modal) => {
    $$("[data-modal-close]", modal).forEach((c) => c.addEventListener("click", () => closeModal(modal)));
    // basic focus trap within the open modal
    modal.addEventListener("keydown", (e) => {
      if (e.key !== "Tab") return;
      const f = $$('a[href], button:not([disabled]), input, [tabindex]:not([tabindex="-1"])', modal).filter((el) => el.offsetParent !== null);
      if (!f.length) return;
      const first = f[0], last = f[f.length - 1];
      if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
    });
  });
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape") { const m = $(".modal.is-open"); if (m) closeModal(m); }
  });
})();
